import React, { useContext } from 'react';
import { UserContext } from '../functions/Auth';

// mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

// icons
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export default function Account() {
    const userInfo = useContext(UserContext);
    console.log(userInfo);

    const information = [
        {
            label: "姓名",
            value: "テスト",
        },
        {
            label: "性別",
            value: "テスト",
        },
        {
            label: "メールアドレス",
            value: "",
        },
        {
            label: "生年月日",
            value: "",
        },
        {
            label: "医師登録年",
            value: "",
        },
        {
            label: "勤務先国",
            value: "",
        },
        {
            label: "診療科",
            value: "",
        },
        {
            label: "勤務先",
            value: "",
        },
        {
            label: "専門医資格",
            value: "",
        },
        {
            label: "専門分野",
            value: "",
        },
        {
            label: "タイムゾーン",
            value: "",
        },
    ]

    return (
        <Box
            sx={{
                maxWidth: "712px",
                mx: "auto",
                my: 2,
                px: 2,
            }}
        >
            <Box
                sx={{
                    px: 2,
                    py: 3,
                }}
            >
                <Button variant="text" color="inherit" startIcon={<ArrowBackIosNewIcon />}>
                    戻る
                </Button>
            </Box>
            <Box
                sx={{
                    px: {mb: 2, tb: 4},
                    py: 3,
                    backgroundColor: (theme) => theme.palette.common.white,
                }}
            >
                <Typography
                    align="center"
                    variant="h1"
                    sx={{
                        mb: 3,
                        fontSize: 20,
                        fontWeight: "bold",
                    }}
                >
                    会員情報
                </Typography>
                <List>
                    {information.map((item) => (
                        <ListItem
                            key={item.label}
                            disablePadding
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                pt: 3,
                                px: 0,
                                pb: 0,
                                [`&:first-of-type`]: {
                                    pt: 0,
                                }
                            }}
                        >
                            <Typography
                                variant="h2"
                                sx={{
                                    mb: 0.5,
                                    fontSize: 16,
                                    fontWeight: "bold",
                                }}
                            >
                                {item.label}
                            </Typography>
                           
                            <Typography
                                paragraph
                                sx={{
                                    mb: 0,
                                }}
                            >
                                {item.value}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
}